<template>
  <div class="phone-wrap">
    <div class="steps" role="tablist" aria-label="مراحل در اپ">
      <button v-for="(step, index) in steps" :key="step.key" type="button" role="tab" :aria-selected="index === current ? 'true' : 'false'"
              :class="{ active: index === current }" @click="current = index">
        <VnIcon :name="step.photo ? 'camera' : 'section'" />{{ step.title }}
      </button>
    </div>
    <div class="phone" aria-label="پیش‌نمایش اپ میدانی">
      <div class="p-top">
        <span class="p-back">‹</span>
        <div><small>{{ formName }}</small><b>{{ step ? step.title : 'مرحله‌ای نیست' }}</b></div>
      </div>
      <span class="vn-bars" />
      <div class="p-body">
        <template v-if="step && !step.photo">
          <p v-if="step.item.description" class="p-desc">{{ step.item.description }}</p>
          <article v-for="(question, index) in visibleQuestions" :key="question._k" class="p-card">
            <header><span class="p-num vn-num">{{ fa(index + 1) }}</span><h3>{{ question.text || 'متن پرسش' }}<i v-if="question.is_mandatory || step.item.is_mandatory">*</i></h3></header>
            <p v-if="question.description" class="p-help">{{ question.description }}</p>
            <AnswerPreview v-for="slot in question.answers" :key="slot.answer_type" class="p-input" :kind="kindName(slot)" :question="question" :rules="slot.rule.fields || {}" />
            <div v-if="photoSteps(question).length" class="p-linked"><VnIcon name="camera" />{{ photoSteps(question).map(p => p.verbose_name).join('، ') }}</div>
          </article>
          <p v-if="!visibleQuestions.length" class="p-empty">این بخش پرسش فعالی ندارد.</p>
        </template>
        <template v-else-if="step">
          <article class="p-card photo">
            <h3>{{ step.item.verbose_name }}</h3>
            <p v-if="step.item.description" class="p-help">{{ step.item.description }}</p>
            <div class="p-shots">
              <span v-for="n in Math.min(Math.max(step.item.min || 1, 1), 4)" :key="n" class="p-shot"><VnIcon name="camera" /></span>
            </div>
            <small class="p-meta vn-num">{{ fa(step.item.min) }} تا {{ fa(step.item.max) }} تصویر{{ step.item.is_mandatory ? ' · اجباری' : '' }}</small>
          </article>
        </template>
        <p v-else class="p-empty">برای پیش‌نمایش، بخش یا مرحله‌ی تصویر بسازید.</p>
      </div>
      <div class="p-foot"><span class="p-btn ghost">قبلی</span><span class="p-btn">ثبت و ادامه</span></div>
    </div>
  </div>
</template>

<script>
import VnIcon from '@/components/VnIcon/index.vue';
import AnswerPreview from './AnswerPreview.vue';
import { fa, questionRef } from '../designerModel';

export default {
  name: 'PhonePreview',
  components: { VnIcon, AnswerPreview },
  props: {
    branch: { type: Object, required: true },
    formName: { type: String, default: '' },
    typesById: { type: Object, required: true },
    focusKey: { type: String, default: '' },
  },
  data: () => ({ current: 0 }),
  computed: {
    steps() {
      return [
        ...this.branch.sections.filter(section => section.is_active).map(section => ({ key: section._k, title: section.verbose_name || 'بخش', item: section })),
        ...this.branch.photos.filter(photo => photo.is_active).map(photo => ({ key: photo._k, title: photo.verbose_name || 'تصویر', item: photo, photo: true })),
      ];
    },
    step() { return this.steps[Math.min(this.current, this.steps.length - 1)]; },
    visibleQuestions() { return this.step ? this.step.item.questions.filter(question => question.is_active) : []; },
  },
  watch: {
    focusKey: { immediate: true, handler(key) { this.jumpTo(key); } },
  },
  methods: {
    fa,
    kindName(slot) { const type = this.typesById[slot.answer_type]; return type ? type.name : ''; },
    photoSteps(question) { const ref = questionRef(question); return this.branch.photos.filter(photo => photo.is_active && photo.question === ref); },
    // follow the canvas selection: a question shows its section
    jumpTo(key) {
      if (!key) return;
      const index = this.steps.findIndex(step => step.key === key || (!step.photo && step.item.questions.some(question => question._k === key)));
      if (index >= 0) this.current = index;
    },
  },
};
</script>

<style scoped>
.phone-wrap { display: grid; gap: 14px; justify-items: center; }
.steps { display: flex; flex-wrap: wrap; justify-content: center; gap: 6px; max-width: 640px; }
.steps button { display: inline-flex; align-items: center; gap: 6px; min-height: 32px; padding: 4px 12px; border: 1px solid var(--line); border-radius: 99px; background: var(--surface); font: inherit; font-size: 12px; font-weight: 700; color: var(--text-2); cursor: pointer; }
.steps button .vn-icon { width: 14px; height: 14px; }
.steps button.active { background: var(--navy-900); border-color: var(--navy-900); color: #fff; --icon-accent: var(--amber-500); }
.phone { width: 360px; max-width: 100%; height: 640px; display: flex; flex-direction: column; border: 10px solid var(--navy-950); border-radius: 34px; background: #F5F6FA; overflow: hidden; box-shadow: var(--shadow-pop); }
.p-top { display: flex; align-items: center; gap: 10px; padding: 14px 14px 12px; background: var(--navy-900); color: #fff; }
.p-top > div { display: grid; min-width: 0; }
.p-top small { font-size: 10.5px; color: var(--shell-text-2); }
.p-top b { font-size: 14px; font-weight: 900; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.p-back { font-size: 22px; line-height: 1; color: var(--shell-text-2); }
.phone .vn-bars { direction: ltr; }
.p-body { flex: 1; overflow-y: auto; padding: 12px; display: grid; gap: 10px; align-content: start; }
.p-desc { margin: 0; font-size: 12px; color: var(--text-3); }
.p-card { display: grid; gap: 8px; padding: 12px; border: 1px solid var(--line); border-radius: 4px; background: #fff; }
.p-card header { display: flex; gap: 8px; align-items: flex-start; }
.p-num { flex: none; width: 22px; height: 22px; display: grid; place-items: center; border-radius: 3px; background: var(--navy-900); color: var(--amber-500); font-size: 11px; font-weight: 800; }
.p-card h3 { margin: 0; font-size: 13px; font-weight: 800; line-height: 1.8; color: var(--text); }
.p-card h3 i { color: var(--pink-700); font-style: normal; margin-inline-start: 3px; }
.p-help { margin: 0; font-size: 11.5px; color: var(--text-3); line-height: 1.8; }
.p-input { margin-top: 2px; }
.p-linked { display: flex; align-items: center; gap: 6px; padding: 6px 8px; border-radius: 3px; background: var(--amber-50); color: var(--amber-700); font-size: 11px; font-weight: 700; }
.p-linked .vn-icon { width: 14px; height: 14px; }
.p-shots { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; }
.p-shot { aspect-ratio: 4 / 3; display: grid; place-items: center; border: 2px dashed var(--line-strong); border-radius: 4px; color: var(--text-4); }
.p-meta { font-size: 11px; color: var(--text-3); }
.p-empty { margin: 30px 0; text-align: center; font-size: 12px; color: var(--text-3); }
.p-foot { display: flex; gap: 8px; padding: 10px 12px; background: #fff; border-top: 1px solid var(--line); }
.p-btn { flex: 1; display: grid; place-items: center; min-height: 40px; border-radius: 4px; background: var(--teal-500); color: var(--navy-900); font-size: 13px; font-weight: 900; }
.p-btn.ghost { flex: 0 0 80px; background: var(--navy-50); color: var(--navy-900); }
</style>
